module.exports = __webpack_public_path__ + "static/media/dwellPass-logo-red-800w.c409eed5.png";